import api from 'api';
import Design from 'records/Design';
import DesignItemMapping from 'records/DesignItemMapping';
import { updateDesignSectionAsync } from 'actions/designSection';
import { updateDesignItemAsync } from 'actions/designItem';
import { updateMenuAsync } from 'actions/menu';
import { updateBuzzCardAsync } from 'actions/buzzCard';
import { updatePosterAsync } from 'actions/poster';
import { updateCustomDesignAsync } from 'actions/customSize';
import { designTypeMap } from 'constants/designType';

export const DESIGN_ASYNC_ACTION_START = 'DESIGN_ASYNC_ACTION_START';
export const DESIGN_ASYNC_ACTION_SUCCESS = 'DESIGN_ASYNC_ACTION_SUCCESS';
export const DESIGN_UPLOAD_ASYNC_ACTION_SUCCESS = 'DESIGN_UPLOAD_ASYNC_ACTION_SUCCESS';
export const DESIGN_ASYNC_ACTION_ERROR = 'DESIGN_ASYNC_ACTION_ERROR';
export const DESIGN_VERSION_ASYNC_ACTION_SUCCESS = 'DESIGN_VERSION_ASYNC_ACTION_SUCCESS';
export const DESIGN_UPDATE_ASYNC_ACTION_SUCCESS = 'DESIGN_UPDATE_ASYNC_ACTION_SUCCESS';
export const DESIGN_UPDATE_ACTION_SUCCESS = 'DESIGN_UPDATE_ACTION_SUCCESS';
export const DESIGN_UPDATE_KEY_ACTION_SUCCESS = 'DESIGN_UPDATE_KEY_ACTION_SUCCESS';
export const DESIGN_ARCHIVE_ACTION_SUCCESS = 'DESIGN_ARCHIVE_ACTION_SUCCESS';
export const DESIGN_RESET_STATE = 'DESIGN_RESET_STATE';
export const DESIGN_CREATE_MENU_ACTION_SUCCESS = 'DESIGN_CREATE_MENU_ACTION_SUCCESS';
export const DESIGN_ASYNC_MENUTYPE_ERROR = 'DESIGN_ASYNC_MENUTYPE_ERROR';
export const DESIGN_RETURN_ACTION_SUCCESS = 'DESIGN_RETURN_ACTION_SUCCESS';
export const DESIGN_UPDATE_PAGE_ORDINALS_ACTION_SUCCESS = 'DESIGN_UPDATE_PAGE_ORDINALS_ACTION_SUCCESS';
export const DESIGN_UPDATE_PAGE_ORDINALS_ACTION_ERROR = 'DESIGN_UPDATE_PAGE_ORDINALS_ACTION_ERROR';
export const DESIGN_ADD_PAGE_ASYNC_ACTION_SUCCESS = 'DESIGN_ADD_PAGE_ASYNC_ACTION_SUCCESS';
export const DESIGN_DELETE_PAGE_ASYNC_ACTION_SUCCESS = 'DESIGN_DELETE_PAGE_ASYNC_ACTION_SUCCESS';
export const DESIGNS_SET_DOWNLOAD_STATE = 'DESIGNS_SET_DOWNLOAD_STATE';
export const DESIGNS_RESET_DOWNLOAD_STATE = 'DESIGNS_RESET_DOWNLOAD_STATE';
export const FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_START = 'FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_START';
export const FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_SUCCESS = 'FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_SUCCESS';
export const FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_ERROR = 'FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_ERROR';

function designAsyncActionStart() {
  return {
    type: DESIGN_ASYNC_ACTION_START,
  };
}

function designAsyncActionSuccess(data) {
  return {
    type: DESIGN_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function designAsyncActionError(error) {
  return {
    type: DESIGN_ASYNC_ACTION_ERROR,
    error,
  };
}

function designUploadAsyncActionSuccess() {
  return {
    type: DESIGN_UPLOAD_ASYNC_ACTION_SUCCESS,
  };
}

function designVersionAsyncSuccess(data) {
  return {
    type: DESIGN_VERSION_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function designUpdateAsyncSuccess(data) {
  return {
    type: DESIGN_UPDATE_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function designAsyncArchiveSuccess() {
  return {
    type: DESIGN_ARCHIVE_ACTION_SUCCESS,
  };
}

function designReturnActionSuccess() {
  return {
    type: DESIGN_RETURN_ACTION_SUCCESS,
  };
}

export function updateDesign(data) {
  return {
    type: DESIGN_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function updateDesignKey(key, value) {
  return {
    type: DESIGN_UPDATE_KEY_ACTION_SUCCESS,
    key,
    value,
  };
}

export function resetDesignState() {
  return {
    type: DESIGN_RESET_STATE,
  };
}

export function reorderDesignPageSucc(){
  return {
    type: DESIGN_UPDATE_PAGE_ORDINALS_ACTION_SUCCESS,
  };
}

export function reorderDesignPageError(error){
  return {
    type: DESIGN_UPDATE_PAGE_ORDINALS_ACTION_ERROR,
    error,
  };
}

function designAddPageAsyncActionSuccess() {
  return {
    type: DESIGN_ADD_PAGE_ASYNC_ACTION_SUCCESS,
  };
}

function designDeletePageAsyncActionSuccess() {
  return {
    type: DESIGN_DELETE_PAGE_ASYNC_ACTION_SUCCESS,
  };
}

export function setDesignDownloadState(state) {
  return {
    type: DESIGNS_SET_DOWNLOAD_STATE,
    state
  };
}

export function resetDesignDownloadState() {
  return {
    type: DESIGNS_RESET_DOWNLOAD_STATE,
  };
}

function fetchLowResPdfLinkAsyncActionStart() {
  return {
    type: FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_START,
  };
}

function fetchLowResPdfLinkAsyncActionSuccess() {
  return {
    type: FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_SUCCESS,
  };
}

function fetchLowResPdfLinkAsyncActionError(error) {
  return {
    type: FETCH_LOW_RES_PDF_LINK_ASYNC_ACTION_ERROR,
    error,
  };
}

export function getDesignAsync(id) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request(`design/${ id }`, 'get')
    .then((data) => {
      dispatch(designAsyncActionSuccess(data[0]));
      return new Design(data[0]);
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to get design'));
      throw (err);
    });
  };
}

export function getDesignAfterChangeBkgdAsync(id) {
  return (dispatch, getState) => {
    
    const design = getState().design.get('data');
    dispatch(designAsyncActionStart());
    return api.request(`design/${ id }`, 'get')
    .then((data) => {
      let changedBackgroundDesign = Design.updateDesignAfterChangeBkgd(new Design(data[0]), design);
      dispatch(updateDesign(changedBackgroundDesign));
      return changedBackgroundDesign;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to update changed background design'));
      throw (err);
    });
  };
}

export function returnLatestDesign(id) {
  return (dispatch, getState) => {
    
    const design = getState().design.get('data');
    dispatch(designAsyncActionStart());
    return api.request(`design/${ id }`, 'get')
    .then((data) => {
      let changedBackgroundDesign = Design.updateDesignAfterChangeBkgd(new Design(data[0]), design);
      dispatch(designReturnActionSuccess());
      return changedBackgroundDesign;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to get design'));
      throw (err);
    });
  };
}

/**
 * Create design
 * @param {*} design 
 * @param {*} isInDesign if true create design for InDesign file upload 
 * @returns 
 */
export function createDesignAsync(design, isInDesign=false) {
  let path = 'design';
  if (isInDesign) path += '?inDesign=true';
  return (dispatch) => {
    dispatch(designAsyncActionStart());
    return api.request(path, 'post', design)
    .then((data) => {
      dispatch(designAsyncActionSuccess(data));
      return new Design(data);
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to create design'));
      throw (err);
    });
  };
}

/**
 * Upload design file FormData
 * @param {FormData} fileData 
 * @returns 
 */
export function uploadDesignFile(fileData) {
  return (dispatch) => {
    dispatch(designAsyncActionStart());
    return api.request('design/uploadInDesign', 'post', fileData, api.contentTypes.form)
      .then(createdFile => {
        dispatch(designUploadAsyncActionSuccess());
        return createdFile;
      })
      .catch((err) => {
        dispatch(designAsyncActionError('Unable to upload design file'));
        throw (err);
      });
  };
}

export function updateDesignAsync(design) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request('design', 'put', design)
    .then((data) => {
      dispatch(designUpdateAsyncSuccess(data));
      return new Design(data);
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to update design'));
      throw (err);
    });
  };
}

export function addDesignPageAsync(design) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request('design/addDesignPage', 'post', design)
    .then((data) => {
      dispatch(designAddPageAsyncActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to add design page'));
      throw (err);
    });
  };
}

export function addBuzzCardDesignPageAsync(design) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request('design/buzzcard/addDesignPage', 'post', design)
    .then((data) => {
      dispatch(designAddPageAsyncActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to add buzzcard design page'));
      throw (err);
    });
  };
}

export function deleteDesignPageAsync(design) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request('design/deleteDesignPage', 'post', design)
    .then((data) => {
      dispatch(designDeletePageAsyncActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to delete design page'));
      throw (err);
    });
  };
}

export function deleteBuzzCardDesignPageAsync(design) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request('design/buzzcard/deleteDesignPage', 'post', design)
    .then((data) => {
      dispatch(designDeletePageAsyncActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to delete buzzcard design page'));
      throw (err);
    });
  };
}

export function getSaveMenuDataPromises(userChanges, surfaceDef, promises) {
  return (dispatch, getState) => {
    const design = getState().design.get('data');
    const designItemMappings = getState().designItemMappings.get('data');
    const menu = getState().menu.get('data');
    const buzzCard = getState().buzzCard.get('data');
    const poster = getState().poster.get('data');
    const designParameter = getState().designParameter.get('data');
    const pageIndex = designParameter.get('currentDesignPageIndex');
    // update designItemMappings from userChanges
    if (design.get('menuId') > 0) {
      // filter out the Buzz card & Poster designs
      const newDesignMappings = DesignItemMapping.updateDesignMapsValuesFromUserChanges(
        designItemMappings,
        userChanges,
        surfaceDef,
        pageIndex
      );
      // Get Brand Name
      //const newBrandName = DesignItemMapping.createBrandNameFromDesignMappings(newDesignMappings);
      // Get updated menuItems, designSections, and menu
      const newMenu = DesignItemMapping.createDesignMenuFromDesignMappings(newDesignMappings, menu);
      const newDesignSections = DesignItemMapping.createDesignSectionsListFromDesignMappings(
        newDesignMappings,
        design
      );

      // update promise array with menu promise that always resolves
      promises.push(
        new Promise(resolve => {
          return dispatch(
            updateMenuAsync({
              id: newMenu.get('id'),
              title: newMenu.get('title'),
              locationId: newMenu.get('locationId'),
              description: newMenu.get('description'),
              archived: newMenu.get('archived'),
            })
          )
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              resolve(true);
            });
        })
      );

      const updDesignItems = DesignItemMapping.createDesignItemListsFromDesignMappings(
        newDesignMappings,
        design
      );
      updDesignItems.forEach(designItem => {
        promises.push(
          new Promise(resolve => {
            dispatch(
              updateDesignItemAsync({
                menuItemId: designItem.get('menuItemId'),
                id: designItem.get('id'),
                designSectionId: designItem.get('designSectionId'),
                ordinal: designItem.get('ordinal'),
                title: designItem.get('title'),
                description: designItem.get('description'),
                price: designItem.get('price'),
                loadToCanvas: designItem.get('loadToCanvas'),
              })
            )
            .then(() => {
                resolve(true);
            })
            .catch(() => {
                resolve(true);
            });
          })
        );
      });

      // update promise array with designSections promise that always resolves
      newDesignSections.forEach(designSection => {
        promises.push(
          new Promise(resolve => {
            return dispatch(
              updateDesignSectionAsync({
                id: designSection.get('id'),
                designPageId: designSection.get('designPageId'),
                userCategoryId: designSection.get('userCategoryId'),
                name: designSection.get('name'),
                description: designSection.get('description'),
                ordinal: designSection.get('ordinal'),
                loadToCanvas: true
              })
            )
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                resolve(true);
              });
          })
        );
      });
    } else {
      if (design.get('designTypeName') === designTypeMap.BUZZCARD) {
        const newDesignMappings = DesignItemMapping.updateDesignMapsValuesFromUserChanges(
          designItemMappings,
          userChanges,
          surfaceDef,
          pageIndex
        );
        // Get updated menuItems, designSections, and menu
        const newBuzzCard = DesignItemMapping.createDesignBuzzCardFromDesignMappings(
          newDesignMappings,
          buzzCard,
          design.get('designPages'),
        );
        // update promise array with buzz card promise that always resolves
        let updatedBuzzCard = [];
        newBuzzCard.map((buzzCard) => {
          const buzzcardData = {
            id: buzzCard.get('id'),
            designId: buzzCard.get('designId'),
            title: buzzCard.get('title'),
            frontCallout: buzzCard.get('frontCallout'),
            designPageId: buzzCard.get('designPageId'),
          };
          updatedBuzzCard = updatedBuzzCard.concat(buzzcardData);
        });
        if(updatedBuzzCard.length > 0) {
          promises.push(
            new Promise(resolve => {
              return dispatch(updateBuzzCardAsync(updatedBuzzCard))
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                resolve(true);
              });
            })
          );
        }
      }
      if (design.get('designTypeName') === designTypeMap.POSTER) {
        const newDesignMappings = DesignItemMapping.updateDesignMapsValuesFromUserChanges(
          designItemMappings,
          userChanges,
          surfaceDef,
          pageIndex
        );
        // Get updated menuItems, designSections, and menu
        const newPoster = DesignItemMapping.createDesignPosterFromDesignMappings(
          newDesignMappings,
          poster
        );
        // update promise array with poster promise that always resolves
        promises.push(
          new Promise(resolve => {
            return dispatch(
              updatePosterAsync({
                id: newPoster.get('id'),
                designId: newPoster.get('designId'),
                title: newPoster.get('title'),
                message: newPoster.get('message'),
              })
            )
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                resolve(true);
              });
          })
        );
      }
      if (design.get('designTypeName') === designTypeMap.CUSTOM_DESIGN) {
        const customSizeProps = getState().customSize.get('data');
        promises.push(
          new Promise((resolve, reject) => {
            return dispatch(
              updateCustomDesignAsync(design.get('id'), customSizeProps)
            )
              .then(() => resolve(true))
              .catch(err => reject(err));
          })
        );
      }
    }
    return promises;
  }
}

export function getLatestDesignVersion(designId, stateContentFileId) {
  return (dispatch, getState) => {
    //avoid to call api when do new design creation
    if(stateContentFileId === 0 ){
      return new Promise((resolve, reject) => {
        return resolve(null);
      });
    }

    
    return api.request(`designversion/${ designId }/${ stateContentFileId }`, 'get')
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw (err);
    });
  };
}

/**
 * Fetches the latest version for the given designId
 * @param {Number} designId designId
 * @returns {Promise}
 */
export function getLatestDesignVersionByDesignId(designId) {
  return (dispatch, getState) => {

    if (!designId || designId <= 0) {
      return new Promise((_, rej) => rej("Invalid designId"));
    }

    
    return api.request(`designversion/latest/${designId}`, 'get')
      .then(({ version }) => version);
  };
}

export function createDesignVersionAsync(designVersion) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request('designversion', 'post', designVersion)
    .then((data) => {
      dispatch(designVersionAsyncSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to create design'));
      throw (err);
    });
  };
}

export function archiveDesignAsync(id) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request(`design/archive/${ id }`, 'put')
    .then((data) => {
      dispatch(designAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to archive design'));
      throw (err);
    });
  };
}

export function restoreArchiveDesignAsync(id) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request(`design/restoreArchive/${ id }`, 'put')
    .then((data) => {
      dispatch(designAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designAsyncActionError('Unable to restore archived design'));
      throw (err);
    });
  };
}

export function reorderDesignPage(pageOrdinals) {
  return (dispatch, getState) => {
    dispatch(designAsyncActionStart());
    return api.request(`designpage/ordinal`, 'put', pageOrdinals)
    .then((data) => {
      dispatch(reorderDesignPageSucc());
      return data;
    })
    .catch((err) => {
      dispatch(reorderDesignPageError('Unable to reorder design pages'));
      throw (err);
    });
  };
}

/**
 * Fetch hi-res background image url
 * @param {String} contentFileName content file name
 * @returns {Promise}
 */
export function getHiResBackgroundUrl(contentFileName) {
  return (dispatch, getState) => {
    
    return api.request(`design/hiResBackgroundUrl?contentFileName=${contentFileName}`, 'get')
      .then((data) => {
        return data.hiResBackgroundUrl;
      });
  };
}

/**
 * Add pages if idml design has more than one page
 * @param {String} designId design id
 * @returns 
 */
export function addIndesignDesignPagesAsync(designId) {
  return (dispatch) => {
    dispatch(designAsyncActionStart());
    return api.request(`design/designImport/pages?designId=${designId}`, 'post')
      .then((data) => {
        dispatch(designAddPageAsyncActionSuccess());
      })
      .catch((err) => {
        dispatch(designAsyncActionError('Unable to add idml default design pages'));
        throw (err);
      });
  };
}

/**
 * get low resolution pdf link of the design
 * @param {String} stateFileId stateFileId
 * @returns 
 */
 export function getLowResPdfLink(stateFileId) {
  return (dispatch) => {
    dispatch(fetchLowResPdfLinkAsyncActionStart());
    return api.request(`design/pdf/lowRes?stateFileId=${stateFileId}`, 'get')
      .then((data) => {
        dispatch(fetchLowResPdfLinkAsyncActionSuccess());
        return data;
      })
      .catch((err) => {
        dispatch(fetchLowResPdfLinkAsyncActionError('Unable to fetch low resolution pdf link'));
        throw (err);
      });
  };
}